import { stripMarkdown } from './Markdown';

// The ONE truncation helper. Truncate on a WORD boundary (2026-08-02,
// web-Claude research session): the hard slice cut fork text mid-word, which on
// a contested-claim card reads as a corrupted claim rather than a shortened
// one. The 0.6 floor is the guard for a single token longer than the budget —
// there is no boundary to find in a URL, and backing up to the previous space
// would drop most of the text; cut it hard instead.
//
// Consolidated 2026-08-07 from nine per-file copies, all with the same hard
// slice and only their default lengths differing; each call surface keeps its
// own length by passing n (most keep a one-line local wrapper so their default
// stays visible in the file). TrustDomain.js keeps its private copy on purpose
// — that surface is frozen by decision and takes no further edits.
export const snip = (s, n = 160) => {
  if (!s) return '';
  if (s.length <= n) return s;
  const cut = s.slice(0, n);
  const brk = cut.lastIndexOf(' ');
  return `${(brk > n * 0.6 ? cut.slice(0, brk) : cut).trimEnd()}…`;
};

// Strip markdown, THEN truncate (M-4, Slice C 2026-08-07). Order matters: cut
// first and a `**bold**` run can lose its closing pair, leaving a dangling `**`
// in a feed row — the exact defect this pairing exists to prevent.
//
// Deliberately a SEPARATE export rather than folded into `snip` itself, even
// though that would be one line and would cover every dense surface at once.
// Two reasons. Not every caller renders markdown — the Reader's popovers quote
// a document body that renders RAW by rule, and stripping there would make the
// summary disagree with the text right under it. And stripping is lossy on
// prose nobody meant as markup: a claim reading `5 * 3 * 2` has its asterisks
// eaten as emphasis. That cost is worth paying where the full view renders
// markdown too, and not worth paying anywhere else, so the choice stays at the
// call site where someone can see it.
export const snipMarkdown = (s, n = 160) => snip(stripMarkdown(s), n);
